export const actions = {
  set: 'SET::MENU'
}

export const setMenu = menu => ({ type: actions.set, menu: menu })
export const getMenu = state => state.menu

export default actions